// settingsApi.ts
import { NGROK } from "../../../../APIs";
import { apiClient } from "../../../../utils/apiClient";
import { myLocalStorage } from "../../../StorageHelper";

export const getGenerationAdminConfig = async (selectedTenant: string, name: string) => {
    if (!selectedTenant) return;
    const url = `${NGROK}/api/${selectedTenant}/generalsettings`
    const data = await apiClient({
        method: "GET",
        url: url
    });
    const configValue = data?.find((config: any) => config.settingsName === name);

    return configValue;
};

export const saveConfigureAdminSettings = async (selectedTenant: string, name: string) => {
    if (!selectedTenant) return;
    const url = `${NGROK}/api/${selectedTenant}/addgeneralsettings?settingValue=${name}&settingName=endpointConfig`
    const data = await apiClient({
        method: "POST",
        url: url
    });

    return data;
};

export const updateSsoGeneralSetting = async (selectedTenant: string, enabled: boolean) => {
    if (!selectedTenant) return;
    const url = `${NGROK}/api/${selectedTenant}/generalsettings/sso?enabled=${enabled}`;
    const data = await apiClient({
        method: "POST",
        url: url,
    });

    return data;
};

export const fetchEmails = async (tenantName: string) => {
    const url = `${NGROK}/api/emails/to-address?tenantName=${tenantName}`
    const data = await apiClient({
        method: "GET",
        url: url
    });

    return data;
};

export const checkIfNotificationsEnabled = async (tenantName: string) => {
    const url = `${NGROK}/api/emails/to-address/enabled?tenantName=${tenantName}`
    const data = await apiClient({
        method: "GET",
        url: url
    });

    return data;
};

export const postEmails = async (postBody: any) => {
    const url = `${NGROK}/api/emails/to-address`
    const data = await apiClient({
        method: "POST",
        url: url,
        data: postBody
    });

    return data;
};

export const gcpConfig = async (tenantName: string) => {
    if (!tenantName) return;
    let url = `${NGROK}/api/gcp/auth/configuration?tenantName=${tenantName}`
    const data = await apiClient({
        method: "GET",
        url: url
    });
    return data;
}

export const gcpUnConfig = async (tenantName: string, projectId: string) => {
    if (!tenantName) return;
    let url = `${NGROK}/api/gcp/auth/delete-configuration?tenantName=${tenantName}&projectId=${projectId}`
    const data = await apiClient({
        method: "GET",
        url: url
    });
    return data;
}

export const gcpSaveConfig = async (tenantName: string, formDataWithJson: any) => {
    const latestTenant = myLocalStorage.getItem("latestTenant")?.tenantName;

    if (!latestTenant) return;
    let url = `${NGROK}/api/gcp/auth/upload-configuration?tenantName=${latestTenant}`
    const data = await apiClient({
        method: "POST",
        url: url,
        data: formDataWithJson
    });
    return data;
}

export const azureFetchConfig = async (tenantName: string) => {
    if (!tenantName) return;
    let url = `${NGROK}/api/azure/auth/configuration?tenantName=${tenantName}`
    const data = await apiClient({
        method: "GET",
        url: url
    });
    return data;
}

export const azureUnConfig = async (tenantName: string) => {
    if (!tenantName) return;
    let url = `${NGROK}/api/azure/v1/tenant?tenantName=${tenantName}`
    const data = await apiClient({
        method: "DELETE",
        url: url
    });
    return data;
}

export const azureConfig = async (tenantName: string, payload: any) => {
    if (!tenantName) return;
    let url = `${NGROK}/api/azure/auth/configure`
    const data = await apiClient({
        method: "POST",
        url: url,
        data: payload
    });
    return data;
}

export const azureUpdateSubIds = async (tenantId: string, subIds: any, tenantName: string) => {
    if (!tenantName) return;
    let url = `${NGROK}/api/azure/auth/update/subscriptionId?tenantId=${tenantId}&wsTenantName=${tenantName}`
    const data = await apiClient({
        method: "PATCH",
        url: url,
        data: subIds
    });
    return data;
}

export const awsFetchConfig = async (tenantName: string) => {
    if (!tenantName) return;
    let url = `${NGROK}/api/aws/cross-account-config?tenantName=${tenantName}`
    const data = await apiClient({
        method: "GET",
        url: url
    });
    return data;
}

export const awsUnConfig = async (tenantName: string, roleName: string) => {
    if (!tenantName) return;
    let url = `${NGROK}/api/aws/unconfig-crossaccount?tenantName=${tenantName}&roleName=${roleName}`
    const data = await apiClient({
        method: "POST",
        url: url
    });
    return data;
}

export const awsConfig = async (tenantName: string, payload: any) => {
    if (!tenantName) return;
    let url = `${NGROK}/api/aws/setup-crossaccount`
    const data = await apiClient({
        method: "POST",
        url: url,
        data: payload
    });
    return data;
}

export const fetchTenants = async () => {
    const url = `${NGROK}/api/get-all-domains`;
    const data = await apiClient({
        method: "GET",
        url: url
    });
    return data || [];
};

export const githubGetConfiguration = async (tenantName: string) => {
    if (!tenantName) return [];
    const url = `${NGROK}/api/saas/github/auth/get-configuration?tenantName=${tenantName}`;
    const data = await apiClient({
        method: "POST",
        url: url
    });
    return data || [];
};

export const githubConfigure = async (payload: any) => {
    const url = `${NGROK}/api/saas/github/auth/configure`;
    const data = await apiClient({
        method: "POST",
        url: url,
        data: payload
    });
    return data;
};

export const githubGetInstallUrl = async (tenantName: string, orgLogin: string, instanceUrl: string = "https://github.com") => {
    if (!tenantName || !orgLogin) return;
    const url = `${NGROK}/api/saas/github/auth/install-url?tenantName=${encodeURIComponent(tenantName)}&orgLogin=${encodeURIComponent(orgLogin)}&instanceUrl=${encodeURIComponent(instanceUrl)}`;
    const data = await apiClient({
        method: "GET",
        url: url
    });
    return data;
};

export const githubDeleteConfiguration = async (tenantName: string, instanceUrl?: string, orgLogin?: string) => {
    if (!tenantName) return;
    let url = `${NGROK}/api/saas/github/auth/disconnect?tenantName=${encodeURIComponent(tenantName)}`;

    if (instanceUrl) {
        url += `&instanceUrl=${encodeURIComponent(instanceUrl)}`;
    }

    if (orgLogin) {
        url += `&orgLogin=${encodeURIComponent(orgLogin)}`;
    }

    const data = await apiClient({
        method: "DELETE",
        url: url
    });
    return data;
};

/* ----------------------------- GitLab Settings ----------------------------- */

export const gitlabGetConfiguration = async (tenantName: string) => {
    if (!tenantName) return [];
    const url = `${NGROK}/api/saas/gitlab/auth/get-configuration?tenantName=${encodeURIComponent(tenantName)}`;
    const data = await apiClient({
        method: "GET",
        url: url
    });
    return data || [];
};

export const gitlabConfigure = async (payload: any) => {
    const url = `${NGROK}/api/saas/gitlab/auth/configure`;
    const data = await apiClient({
        method: "POST",
        url: url,
        data: payload
    });
    return data;
};

export const gitlabDeleteConfiguration = async (tenantName: string, instanceUrl: string = "https://gitlab.com") => {
    if (!tenantName) return;
    const url = `${NGROK}/api/saas/gitlab/auth/delete-configuration?tenantName=${encodeURIComponent(tenantName)}&instanceUrl=${encodeURIComponent(instanceUrl)}`;
    const data = await apiClient({
        method: "GET",
        url: url
    });
    return data;
};